//* Deals Row Link Controller
//*
//* Makes a whole deal row/card clickable, navigating to the deal page.
//* Clicks on real links or buttons inside the row are left alone.
import ApplicationController from "application_controller.js";

export default class extends ApplicationController {
  debug = false;

  static values = { url: String };

  visit(event) {
    if (event.target.closest("a, button")) return;

    //* Honour open-in-new-tab conventions (cmd/ctrl/shift click)
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      window.open(this.urlValue, "_blank");
      return;
    }

    window.Turbo.visit(this.urlValue);
  }
}
